export default {
  wpUtilities: {
    path: '/wp-utilities',
    label: 'WP Utilities',
  },
  sgReport: {
    path: '/sg-report',
    label: 'SG Reports',
  },
  giveCardIssue: {
    path: '/givecards/:id/issues',
    label: 'GiveCard Issues',
  },
  register: {
    path: '/register',
    label: 'Register'
  },
}
